/* eslint-disable dot-notation */
import axios from 'axios';

export function setJwt(jwt) {
	if (jwt === undefined) {
		delete axios.defaults.headers.common['Authorization'];
	} else {
		axios.defaults.headers.common['Authorization'] = jwt;
	}
}

export default {
	get: axios.get,
	post: axios.post,
	put: axios.put,
	delete: axios.delete,
	setJwt,
};
